import { render, staticRenderFns } from "./SectionItemReview.vue?vue&type=template&id=17c7da10&scoped=true&lang=pug&"
import script from "./SectionItemReview.vue?vue&type=script&lang=js&"
export * from "./SectionItemReview.vue?vue&type=script&lang=js&"
import style0 from "./SectionItemReview.vue?vue&type=style&index=0&id=17c7da10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c7da10",
  null
  
)

export default component.exports